module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA+0lEQVR4Ad1Qs1qGYRj+bU3Ztm3X25Jtu60DaW5vyo0dRHbnkbv7rF/fFu7reuxH82sAKXk8Hih9TqfTy+e3QX1DAywWC3pCQzEfGwuT0YhWQtQ3sNlsWK+owFVfH+4nJrBRXBx4A/jAcV0d7kZH8Tg/j4PcXHy+v0MBscEJ1UNKuxS1U3RWUIDr8nJ0Ufo2RYo8/w22KMql6JoQPA0MoILSN9U1EDcgFJ1zG3QG2wAKfH1+4ria+sHICB7m5nCQmYOPl1f/P9DMayAl/aIBvbOpuOnrx+P4FMZHk2BYMkCR57+BZdkC7bwWo71RWOtJYnTLilV1A/X0P/AN7iMcXCgfVnkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/KE.png
// module id = 1178
// module chunks = 0